import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { API_BASED_URL } from '../config.js';

const SupervisorChangePassword = () => {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showCurr, setShowCurr] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConf, setShowConf] = useState(false);
  const token = localStorage.getItem('userToken');

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (newPassword !== confirmPassword) {
      setError('New password and confirm password must match');
      return;
    }
    if (newPassword.length < 6) {
      setError('New password must be at least 6 characters');
      return;
    }
    try {
      setLoading(true);
      const res = await fetch(`${API_BASED_URL}api/supervisor/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: token },
        body: JSON.stringify({ currentPassword, newPassword })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.message || 'Failed to change password');
      setMessage('Password updated successfully');
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-md mx-auto bg-white rounded-xl shadow">
      <h2 className="text-2xl font-semibold mb-4">Change Password</h2>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Current Password</label>
          <div className="relative">
            <input type={showCurr ? 'text' : 'password'} value={currentPassword} onChange={(e)=>setCurrentPassword(e.target.value)} className="w-full border rounded px-3 py-2 pr-10" required />
            <button type="button" aria-label={showCurr ? 'Hide password' : 'Show password'} onClick={()=>setShowCurr(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showCurr ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">New Password</label>
          <div className="relative">
            <input type={showNew ? 'text' : 'password'} value={newPassword} onChange={(e)=>setNewPassword(e.target.value)} className="w-full border rounded px-3 py-2 pr-10" required />
            <button type="button" aria-label={showNew ? 'Hide password' : 'Show password'} onClick={()=>setShowNew(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showNew ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Confirm New Password</label>
          <div className="relative">
            <input type={showConf ? 'text' : 'password'} value={confirmPassword} onChange={(e)=>setConfirmPassword(e.target.value)} className="w-full border rounded px-3 py-2 pr-10" required />
            <button type="button" aria-label={showConf ? 'Hide password' : 'Show password'} onClick={()=>setShowConf(v=>!v)} className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex w-7 h-7 items-center justify-center p-0.5 rounded-md text-gray-500 hover:text-gray-700 bg-transparent hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500">{showConf ? <EyeOff size={18}/> : <Eye size={18}/>}</button>
          </div>
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {message && <div className="text-green-600 text-sm">{message}</div>}
        <button type="submit" disabled={loading} className={`px-4 py-2 rounded text-white ${loading ? 'bg-gray-400' : 'bg-indigo-600 hover:bg-indigo-700'}`}>{loading ? 'Saving...' : 'Save Password'}</button>
      </form>
    </div>
  );
};

export default SupervisorChangePassword;
